import "./CopyTextControl.scss";
import { copyLink } from "utils/share";

export const CopyTextControl = (props: {
  value: string;
}): JSX.Element => {
  const onClick = async () => {
    await copyLink(props.value);
  };

  return (
    <div className="copyControl">
      <input type="text" readOnly value={props.value} />
      <button onClick={onClick}>Copy</button>
    </div>
  );
};
